<template>
    <b-container>
        <h4>EYPR-Narrative List</h4>
        <div class="section-line" />
        <b-form-row>
            <b-col md="5" class="my-2">
                <b-input-group prepend="Filter">
                    <b-form-input v-model="filter" placeholder="Type to filter the table." />
                    <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">
                            Clear
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
            <b-col md="1" />
            <b-col md="5" class="my-2">
                <ay-select v-model="aySelected" :ay-default="isReviewer ? currentAy : null" />
            </b-col>
        </b-form-row>
        <b-table
            id="list-of-eypr-narrative"
            striped
            small
            bordered
            hover
            sort-by="lastUpdate"
            sort-desc
            stacked="md"
            :fields="eyprNarrativeListFields"
            :items="filteredItems"
            caption-top
            :filter="filter"
            @row-clicked="selectEyprNarrative"
        >
            <template slot="empty">
                <span>
                    There are no EYPR-Narrative available for viewing
                </span>
            </template>

            <template v-slot:head(_actions)>
                <b-form-row class="actions-column">
                    <b-col>
                        <fa-icon fixed-width
                                 size="lg"
                                 title="Submit"
                                 :icon="['far','inbox-in']"
                        />
                    </b-col>
                    <b-col class="action-placeholder" />

                    <!-- <b-col>
                        <fa-icon fixed-width
                                 size="lg"
                                 title="Delete"
                                 :icon="['far','trash-alt']"
                        />
                    </b-col> -->
                </b-form-row>
            </template>

            <template v-slot:cell(_actions)="row">
                <b-form-row class="text-right actions-column">
                    <b-col v-if="canSubmit(row.item)">
                        <confirmable-submit-action-button
                            :disabled="!row.item._actions.submit"
                            :actionable-item="row.item"
                            :icon-config="{
                                variant: 'submit',
                                classes: ['fa-fw', 'fa-lg'],
                            }"
                            :submit-words="{itemType: 'Eypr Narrative', action: 'Submit'}"
                            @submitConfirmed="onSubmitConfirm($event)"
                        />
                    </b-col>
                    <b-col class="action-placeholder" />
                    <!-- <b-col v-if="canDelete(row.item)">
                        <confirmable-delete-action-button
                            :disabled="!row.item._actions.delete"
                            :actionable-item="row.item"
                            :icon-config="{
                                variant: 'delete',
                                classes: ['fa-fw', 'fa-lg'],
                            }"
                            :delete-words="{itemType: 'Eypr Narrative', action: 'Delete'}"
                            @deleteConfirmed="onDeleteConfirm(row)"
                        />
                    </b-col>
                    <b-col v-else class="action-placeholder" /> -->
                </b-form-row>
            </template>

            <template slot="table-caption">
                <span>
                    Click a column header to sort the table
                    or click on a row to view/edit the EYPR-Narrative details.
                </span>
            </template>
        </b-table>
        <div v-if="showCreateButton" v-show="showCreateButton">
            <b-button variant="primary" @click="newEyprNarrative">
                {{ createEyprNarrativeButtonText }}
            </b-button>
        </div>
    </b-container>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';

export default {
    name: 'EyprNarrativeList',

    props: {
        // applicationId: { type: [String, Number], required: true },
    },

    data() {
        return {
            // TODO replace localApplicationFields with eyprNarrativeListFields
            eyprNarrativeListFields: [
                { key: 'academicYear', label: 'AY', sortable: true },
                { key: 'eyprNarrativeId', label: 'ID', sortable: true },
                { key: 'applicantName', label: 'Applicant', sortable: true },
                { key: 'applicantId', label: 'FICE', sortable: true },
                { key: 'currentState', label: 'Status', sortable: true },
                {
                    key: 'lastUpdate',
                    label: 'Updated',
                    sortable: true,
                    formatter: (value) => (new Date(value)).toLocaleDateString(),
                },
                {
                    key: '_actions',
                    label: 'Actions',
                    sortable: false,
                    thClass: 'actions-header-2 text-right',
                },
            ],
            filter: null,
            aySelected: null,
        };
    },

    computed: {
        ...mapGetters({
            userPersona: 'auth/userPersona',
            isAuthorized: 'auth/isAuthorized',
            isApplicant: 'auth/isApplicant',
            isReviewer: 'auth/isReviewer',
            currentAy: 'ref/global/currentAy',
            ficeCodeShortName: 'ref/ee/ficeShortName',
            ficeName: 'ref/ee/ficeName',
        }),

        // TODO create eyprNarrative store
        ...mapState('eyprNarrative', {
            eyprNarrativeList: 'eyprNarrativeList',
            eyprNarrativeForm: (state) => state.form,
        }),

        ...mapState('eyprNarrative/form', {
            eyprNarrativeId: (state) => state.eypr_narrative_id
        }),

        payload() {
            return {
                ...this.eyprNarrativeForm,
                academic_year: this.currentAy,
                applicant_id: this.userPersona.applicant_id,
            };
        },

        eyprNarrativeListItems() {
            return this.eyprNarrativeList.map((eyprNarrative) => {
                return {
                    ...eyprNarrative,
                    // FIXME: This should be eyprData
                    academicYear: eyprNarrative.academic_year,
                    eyprNarrativeId: eyprNarrative.eypr_narrative_id,
                    applicantName: this.ficeCodeShortName(eyprNarrative.applicant_id),
                    applicantId: eyprNarrative.applicant_id,
                    currentState: eyprNarrative.state ? eyprNarrative.state.current_state : null,
                    lastUpdate: eyprNarrative.state ? eyprNarrative.state_datetime : null,
                    _actions: {
                        // submit: eyprData.state ? this.isAuthorized('submit', eyprData.state.resource_type) : false,
                        // delete: eyprData.state ? this.isAuthorized('delete', eyprData.state.resource_type) : false,
                        submit: true,
                        // delete: true,
                    },
                };
            });
        },

        filteredItems() {
            return (this.aySelected)
                ? this.eyprNarrativeListItems.filter((item) => Number(item.academicYear) === Number(this.aySelected))
                : this.eyprNarrativeListItems;
        },

        showCreateButton() {
            // return false; // hide the button
            return this.isAuthorized('create', 'eypr_narrative') && !this.hasEyprNarrativeForCurrentAy;
        },

        hasEyprNarrativeForCurrentAy() {
            return this.eyprNarrativeList.some(
                (eyprNarrative) => eyprNarrative.academic_year === this.currentAy
            );
        },
        createEyprNarrativeButtonText() {
            return 'Create Eypr Narrative For AY' + this.currentAy;
        },

    },

    async created() {
        this.$store.dispatch('ref/ee/fetchRefEe', this.currentAy);
        this.fetchEyprNarrativeList();
    },

    methods: {
        // TODO Create eyprNarrative submit action
        ...mapActions({
            fetchEyprNarrativeList: 'eyprNarrative/fetchEyprNarrativeList',
            submitEyprNarrative: 'eyprNarrative/submit',
            createEyprNarrative: 'eyprNarrative/create',
            deleteEyprNarrative: 'eyprNarrative/delete',
        }),

        selectEyprNarrative(row) {
            this.$router.push({
                name: 'eyprNarrative.History',
                params: {
                    eyprNarrativeId: row.eyprNarrativeId,
                    applicantId: row.applicantId,
                    eyprNarrativeAy: row.academicYear,
                },
            });
        },

        // TODO change the authorizition for eypr
        canSubmit(eyprNarrative) {
            // return true;
            return this.isAuthorized('submit', eyprNarrative);
        },

        // canDelete(eyprNarrative) {
        //     return true;
        //     // return this.isAuthorized('delete', eyprNarrative);
        // },

        async newEyprNarrative() {
            await this.$store.dispatch('eyprNarrative/form/reset');
            await this.createEyprNarrative({
                ...this.payload,
            });

            this.$router.push({
                name: 'eyprNarrative.History',
                params: {
                    eyprNarrativeId: this.eyprNarrativeId,
                    applicantId: this.userPersona.applicant_id,
                },
            });
        },

        onSubmitConfirm(row) {
            const eyprNarrativeId = row.eyprNarrativeId;
            console.log('row: ', row);

            this.submitEyprNarrative({ eyprNarrativeId });
            this.$root.$emit('bv::hide::popover');
        },

        // onDeleteConfirm(row) {
        //     // const applicationId = this.applicationId;
        //     const eyprNarrativeId = row.eyprNarrativeId;
        //
        //     this.deleteEyprNarrative({ eyprNarrativeId });
        //     this.$root.$emit('bv::hide::popover');
        // },

    },
};
</script>

<style lang="scss" scoped>
@import '$StyleVars';

h4 {
    text-align: center;
}

h6 {
    text-align: center;
}

td.table-success {
    vertical-align: middle;
    text-align: center;
}

table#list-of-eypr-narrative {
    vertical-align: middle;
    text-align: center;
}

#list-of-eypr-narrative__caption_ {
    font-size: .75rem;
}

tr {
    cursor: pointer;
}

$action-button-width: 50px;
$estimated-description-column-width: calc(
    83vw - (11ch + 8ch + 22ch + (#{$action-button-width * 3}) + (16px * 3))
);

.table {
    .actions-column .col {
        padding-left: 0;
        padding-right: 0;
        white-space: nowrap;

        .action-placeholder {
            width: $action-button-width;
        }
    }

    /deep/ thead {
        th.description {
            width: calc(100% - (50px + 50px + 80px + 125px));
        }

        th.actions-header,
        th.actions-header-1,
        th.actions-header-2,
        th.actions-header-3,
        th.actions-header-4 {
            font-size: 16px;
            font-weight: bold;
            text-align: center;
            white-space: nowrap;

            .col {
                padding: 5px 9px;

                svg {
                    vertical-align: bottom;
                }
            }
        }

        th.actions-header-1 {
            width: ($action-button-width + 8px) * 1;
            min-width: ($action-button-width + 8px) * 1;
        }

        th.actions-header-2 {
            width: ($action-button-width + 8px) * 2;
            min-width: ($action-button-width + 8px) * 2;
        }

        th.actions-header-3 {
            width: ($action-button-width + 8px) * 3;
            min-width: ($action-button-width + 8px) * 3;
        }

        th.actions-header-4 {
            width: ($action-button-width + 8px) * 4;
            min-width: ($action-button-width + 8px) * 4;
        }
    }

    /deep/ tbody {
        tr:hover {
            cursor: pointer;
        }

        td {
            white-space: nowrap;

            .description {
                position: relative;
                width: $estimated-description-column-width;

                &:before {
                    content: attr(title);
                    max-width: 100%;
                    overflow: hidden;
                    position: absolute;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                &:after {
                    content: attr(title);
                    display: inline-block;
                    height: 0;
                    overflow: hidden;
                }
            }
        }
    }
}

</styl
